// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"1709aea1","496":"e6a79554","563":"f3866ca7"}[chunkId] + ".chunk.js";
};